<template lang="html">
    <div :class="{show: showOwnUp}" class="pop-ownup" v-if="componentMounted" data-role="overlay">
        <div class="pop-ownup-bg" @click="hide"></div>
        <div class="pop-ownup-container" >
            <button type="button" aria-label="Dismiss overlay" @click="hide" class="pop-ownup-close"><i class="icon-times"></i></button>
            <div class="own-up-container">
                <div id="own-up-questionnaire"></div>
                <div
                    id="own-up-form-data"
                    :data-property-address="porpertyAddress"
                    :data-property-unit="propertyUnit"
                    :data-property-city="city"
                    :data-property-zip="zipcode"
                    :data-property-state="state"
                    :data-property-county="county"
                    :data-property-type="ownUpPropertyType"
                    :data-purchase-price="price"
                    :data-name="name"
                    :data-email="email"
                    :data-phone="phone"
                    data-loan-purpose="purchase"
                    :data-utm-campaign="cta"
                >
                </div>
            </div>
        </div>
    </div>
</template>
<script src="./mvt-popownup.js"></script>
<style lang="scss">
@use "./mvt-popownup.scss" as *;
</style>